import React from 'react';
import flat from 'flat';
import { es, enUS, ptBR } from 'date-fns/locale';
import spanishMessages from '../i18n/es.json';
import englishMessages from '../i18n/en.json';
import portugueseMessages from '../i18n/pt.json';
import { getCosmosItem } from '../cosmos';


export const locales = {
  es: { localeObj: es, locale: 'es', intlMessages: flat(spanishMessages), name: 'Español', dateFormat: 'dd \'de\' MMMM \'de\' yyyy' },
  en: { localeObj: enUS, locale: 'en', intlMessages: flat(englishMessages), name: 'English', dateFormat: 'MMMM dd, yyyy' },
  pt: { localeObj: ptBR, locale: 'pt', intlMessages: flat(portugueseMessages), name: 'Português', dateFormat: 'dd \'de\' MMMM \'de\' yyyy' },
};

export const getLocale = () => {
  const defaultLocale = getCosmosItem('lang') || 'es';

  // Allow overriding locale via URL param, e.g. ?lang=pt
  const urlParams = new URLSearchParams(window.location.search);
  const urlLocale = urlParams.get('lang');
  if (urlLocale && locales[urlLocale]) {
    localStorage.setItem('educabotLocale', urlLocale);
    return locales[urlLocale];
  }

  const savedLocale = localStorage.getItem('educabotLocale') || defaultLocale;

  return locales[savedLocale] || locales[defaultLocale];
};

/**
 * Save a new locale to session storage.
 * @param {string} locale
 */
export const setLocale = (locale) => {
  if (locales[locale]) {
    localStorage.setItem('educabotLocale', locale);
  } else {
    console.warn(`Locale "${locale}" is not supported.`);
  }
};
